var map = {
	"./menu-Collection.svg": "1690",
	"./menu-Contact.svg": "59ff",
	"./menu-Edit.svg": "4550",
	"./menu-Manage.svg": "c680",
	"./menu-Member.svg": "c06f",
	"./menu-News.svg": "7060",
	"./menu-Setting.svg": "0cba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0fa";